/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

/** Max power to spoof flight envelope protection */
export interface SpoofFlightEnvelopeLimitsActionArgs {
  spoof: boolean;
  maxPower: number;
}

export interface SpoofFlightEnvelopeLimitsResultData {
}

export interface SpoofFlightEnvelopeLimitsActionStateData {
}

function createBaseSpoofFlightEnvelopeLimitsActionArgs(): SpoofFlightEnvelopeLimitsActionArgs {
  return { spoof: false, maxPower: 0 };
}

export const SpoofFlightEnvelopeLimitsActionArgs = {
  encode(message: SpoofFlightEnvelopeLimitsActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.spoof === true) {
      writer.uint32(8).bool(message.spoof);
    }
    if (message.maxPower !== 0) {
      writer.uint32(21).float(message.maxPower);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofFlightEnvelopeLimitsActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofFlightEnvelopeLimitsActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.spoof = reader.bool();
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.maxPower = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpoofFlightEnvelopeLimitsActionArgs {
    return {
      spoof: isSet(object.spoof) ? globalThis.Boolean(object.spoof) : false,
      maxPower: isSet(object.maxPower) ? globalThis.Number(object.maxPower) : 0,
    };
  },

  toJSON(message: SpoofFlightEnvelopeLimitsActionArgs): unknown {
    const obj: any = {};
    if (message.spoof === true) {
      obj.spoof = message.spoof;
    }
    if (message.maxPower !== 0) {
      obj.maxPower = message.maxPower;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofFlightEnvelopeLimitsActionArgs>, I>>(
    base?: I,
  ): SpoofFlightEnvelopeLimitsActionArgs {
    return SpoofFlightEnvelopeLimitsActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofFlightEnvelopeLimitsActionArgs>, I>>(
    object: I,
  ): SpoofFlightEnvelopeLimitsActionArgs {
    const message = createBaseSpoofFlightEnvelopeLimitsActionArgs();
    message.spoof = object.spoof ?? false;
    message.maxPower = object.maxPower ?? 0;
    return message;
  },
};

function createBaseSpoofFlightEnvelopeLimitsResultData(): SpoofFlightEnvelopeLimitsResultData {
  return {};
}

export const SpoofFlightEnvelopeLimitsResultData = {
  encode(_: SpoofFlightEnvelopeLimitsResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofFlightEnvelopeLimitsResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofFlightEnvelopeLimitsResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SpoofFlightEnvelopeLimitsResultData {
    return {};
  },

  toJSON(_: SpoofFlightEnvelopeLimitsResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofFlightEnvelopeLimitsResultData>, I>>(
    base?: I,
  ): SpoofFlightEnvelopeLimitsResultData {
    return SpoofFlightEnvelopeLimitsResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofFlightEnvelopeLimitsResultData>, I>>(
    _: I,
  ): SpoofFlightEnvelopeLimitsResultData {
    const message = createBaseSpoofFlightEnvelopeLimitsResultData();
    return message;
  },
};

function createBaseSpoofFlightEnvelopeLimitsActionStateData(): SpoofFlightEnvelopeLimitsActionStateData {
  return {};
}

export const SpoofFlightEnvelopeLimitsActionStateData = {
  encode(_: SpoofFlightEnvelopeLimitsActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofFlightEnvelopeLimitsActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofFlightEnvelopeLimitsActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SpoofFlightEnvelopeLimitsActionStateData {
    return {};
  },

  toJSON(_: SpoofFlightEnvelopeLimitsActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofFlightEnvelopeLimitsActionStateData>, I>>(
    base?: I,
  ): SpoofFlightEnvelopeLimitsActionStateData {
    return SpoofFlightEnvelopeLimitsActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofFlightEnvelopeLimitsActionStateData>, I>>(
    _: I,
  ): SpoofFlightEnvelopeLimitsActionStateData {
    const message = createBaseSpoofFlightEnvelopeLimitsActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
